module.exports = __webpack_public_path__ + "static/media/why-us-img.c2a076c5.png";